import Politika from './Politika';

export default Politika;


// WEBPACK FOOTER //
// ./src/containers/Politika/index.js